export const COLORS = ["blue", "green", "red", "yellow"] as const;

export const getAllColors = function () {
  return COLORS;
};

export const getColorFromIndex = function (id: number) {
  return COLORS[id % COLORS.length];
};

export const getColorFromHex = function (hex: Nullable<string>) {
  if (!hex) return "white";

  switch (hex.toUpperCase()) {
    case "#2652C7":
      return "blue";

    case "#F3B13F":
      return "yellow";

    case "#65A948":
      return "green";

    case "#D12D1E":
      return "red";

    default:
      return "white";
  }
};

export const getHexFromColor = function (color: string, saturation: number = 300) {
  if (color == "white") return "#FFFFFF";

  // Map saturation to available shades (100, 200, 300)
  let shade = "300";
  if (saturation <= 150) shade = "100";
  else if (saturation <= 250) shade = "200";
  else shade = "300";

  const hex = getColorHex(`--color-${color}-${shade}`).trim();

  if (hex) return hex;

  return getColorHex("--color-primary").trim();
};

export const getColorHex = (cssVariable: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVariable).replace(" ", "");
};

export const getColorsHex = () => {
  return COLORS.map((color) => {
    return getColorHex(`--color-${color}-300`);
  });
};

export const getColorNamesRepeating = (n: number) => {
  const a: string[] = [];

  let i = 0;

  for (let j = 0; j < n; j++) {
    if (i >= COLORS.length) {
      i = 0;
    }

    a.push(COLORS[i]);

    i++;
  }

  return a;
};

// Determistic get a color from COLORS array based on a string
export const getColorFromString = (str: string) => {
  const hash = str.split("").reduce((acc, char) => {
    return acc + char.charCodeAt(0);
  }, 0);

  return getColorFromIndex(hash);
};
